module.exports = __webpack_public_path__ + "img/check.bf75a715.svg";